
import { adminStore } from '@/store';
import _ from 'lodash';
import { Vue, Component } from 'vue-property-decorator';

@Component
export default class Status extends Vue {
  get options() {
    const options = [
      {
        name: 'Online',
        color: 'success',
        icon: 'mdi-check',
        value: true,
      },
      {
        name: 'Offline',
        color: 'error',
        icon: 'mdi-close',
        value: false,
      },
    ];

    return _.filter(options, { value: this.online || false });
  }

  online = false;

  async mounted() {
    this.online = await adminStore.getStatus();
  }
}
